<template>
    <div>
        <app-new-breadcrumb></app-new-breadcrumb>
        <div class="description">
            <div class="description-inner">
            <div class="description-text">
                <h2>{{ $t("internship") }}</h2>
                <p v-html="$t('internshipText')"></p>
            </div>
            <div class="description-img">
                <img src="https://resources.fia.ba/file/C8235237-EDB5-EE11-8B8A-00155D1E1316.jpg" alt="Slika praksa">
            </div>
            </div>
        </div>
        <div class="main">
            <div class="page-inner">
            <div class="big-card">
                <div class="big-card-title">
                    <i class="fa fa-solid fa-desktop"></i>
                    <h3>{{ $t("applicationForm") }}</h3>
                </div>
                <p v-html="$t('applicationFormText')"></p>
                <div class="big-card-btn"><a
                        href="https://resources.fia.ba/file/710746D4-64DD-EF11-8B91-00155D1E1316.docx" target="_blank">
                        {{ $t("link") }}
                    </a></div>
            </div>
            <div class="big-card">
                <div class="big-card-title">
                    <i class="fa fa-solid fa-desktop"></i>
                    <h3>{{ $t("mentor") }}</h3>
                </div>
                <p v-html="$t('mentorText')"></p>
            </div>
            <!-- <div class="small-cards">
                <div class="small-card-item">
                    <h5>{{ $t("internshipComment1") }}</h5>
                    <p class="intern">Praktikant 1</p>
                </div>
                <div class="small-card-item">
                    <h5>{{ $t("internshipComment2") }}</h5>
                    <p class="intern">Praktikant 2</p>
                </div>
                <div class="small-card-item">
                    <h5>{{ $t("internshipComment3") }}</h5>
                    <p class="intern">Praktikant 3</p>
                </div>
            </div> -->
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from "../../common/Breadcrumb.vue";

export default {
    data() {
        return {
        }
    },
    components: {
        appNewBreadcrumb: Breadcrumb,
    },
    methods: {
 
    },
    computed: {
        ...mapGetters(["getContentById", "getContentByUrl"]),
    },
}
</script>

<style scoped>
.main {
    padding: 2% 7% 0% 7%;
    box-sizing: border-box;
}

/*Small cards*/

.small-cards {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    margin-top: 2%;
    margin-bottom: 2%;
}

.small-card-item {
    width: calc((100% - 60px) / 3);
    background-color:  var(--secondary-color);
    padding: 1% 2%;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
}

.small-card-item i,
.small-card-item h5 {
    font-size: 20px;
    color: var(--main-color);
    margin-bottom: 3%;
    text-align: justify;
}

.small-card-btn {
    width: 100%;
    font-size: 18px;
    color: #F68600;
    border: 1px solid #F68600;
    border-radius: 10px;
    text-align: center;
}

.intern {
    text-align: end;
    font-size: 18px;
    color: var(--main-color);
    margin-bottom: 0;
}

/*Small cards end*/

@media only screen and (max-width: 768px) {
    .small-cards{
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .small-card-item{
        width: 100%;
    }

}
</style>